import { graphql } from "../../gql/gql";

export const DIRECTORY_CREATE = graphql(`
  mutation DirectoryCreate($data: CreateDirectoryInput!) {
    directoryCreate(data: $data) {
      name
    }
  }
`);

export const DIRECTORY_UPDATE = graphql(`
  mutation DirectoryUpdate($data: UpdateDirectoryInput!, $directoryId: String!) {
    directoryUpdate(data: $data, directoryId: $directoryId) {
      id
      name
      parentDirectory {
        id
      }
    }
  }
`);

export const DIRECTORY_DELETE = graphql(`
  mutation DirectoryDelete($directoryId: String!) {
    directoryDelete(directoryId: $directoryId) {
      id
    }
  }
`);
